import React, { useEffect, useState } from "react";
import "../scss/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import logo from "../assets/logo.svg";
import { jwtDecode } from "jwt-decode";
const ResetPasswordPage = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("acToken");
  const [tokenExpired, setTokenExpired] = useState(false);
  const isTokenExpired = (token) => {
    if (!token) return true;

    try {
      const decoded = jwtDecode(token);
      console.log("16 ------->    ", decoded.exp * 1000 < Date.now());
      return decoded.exp * 1000 < Date.now();
    } catch (error) {
      return true; // Invalid token
    }
  };
  useEffect(() => {
    const checkEveryMinute = () => {
      const expired = isTokenExpired(token);
      if (expired) {
        setisPasswordUpdated(true);
      }
      setTokenExpired(expired);
    };

    checkEveryMinute();
    const interval = setInterval(checkEveryMinute, 10000);

    return () => clearInterval(interval);
  }, [token]);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPasswordUpdated, setisPasswordUpdated] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    if (!password || !confirmPassword) {
      setError("Please fill in all fields.");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/resetPassword`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ password }),
        }
      );
      console.log(res);
      if (res.status !== 200) {
        setError(res.Message || "Something went wrong.");
        return;
      }

      setMessage(res.Message || "Password updated successfully.");
      setConfirmPassword("");
      setPassword("");
      setisPasswordUpdated(true);
    } catch (err) {
      setError(err || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      ) : tokenExpired ? (
        <div className="reset-password">
          <div className="container" style={{ marginTop: 0 }}>
            <div className="logo">
              <img src={logo} alt="" />
            </div>
            <div className="form-wrapper">
              <h2>Link Expired</h2>
              <p>
                Your reset password link has expired. Please request a new one.
              </p>
            </div>
          </div>
        </div>
      ) : isPasswordUpdated ? (
        <div className="reset-password">
          <div className="container" style={{ marginTop: 0 }}>
            <div className="logo">
              <img src={logo} alt="" />
            </div>
            <div className="form-wrapper">
              <h2>Password Updated</h2>
              <p>Your password has been updated successfully.!!!!</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="reset-password">
          <div className="container">
              <div className="logo">
                <img src={logo} alt="" />
              </div>
            <div className="form-wrapper">
              <h2>Reset Your Password</h2>
              <form onSubmit={handleSubmit}>
                <label>New Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

                <label>Confirm Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />

                {error && <div className="error-msg">{error}</div>}
                {message && <div className="success-msg">{message}</div>}

                <button type="submit" disabled={loading}>
                  {loading ? "Updating..." : "Reset Password"}
                </button>
              </form>
            </div>

            <style>{`
        .container {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          background: linear-gradient(to right, #e0ecff, #f2f7ff);
          font-family: Arial, sans-serif;
        }
        .form-wrapper {
          background: white;
          padding: 2rem;
          border-radius: 10px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          max-width: 400px;
          width: 100%;
        }
        h2 {
          text-align: center;
          margin-bottom: 1.5rem;
          color: #333;
        }
        form {
          display: flex;
          flex-direction: column;
        }
        label {
          margin-bottom: 0.5rem;
          font-weight: 500;
          color: #444;
        }
        input {
          padding: 0.75rem;
          margin-bottom: 1rem;
          border: 1px solid #ccc;
          border-radius: 6px;
          font-size: 1rem;
        }
        button {
          padding: 0.75rem;
          background-color: #4a90e2;
          color: white;
          font-weight: bold;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: background 0.3s;
        }
        button:disabled {
          background-color: #aac6f2;
        }
        .error-msg {
          color: #e74c3c;
          font-size: 0.9rem;
          margin-bottom: 1rem;
        }
        .success-msg {
          color: #27ae60;
          font-size: 0.9rem;
          margin-bottom: 1rem;
        }
      `}</style>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetPasswordPage;
